import { defineComponent as _defineComponent } from 'vue'
import '@/scss/material/sidebar/sidebar-menu.scss';

import store from '@/store';
import router from '@/router';

import { useRoute } from 'vue-router/composables';
import { computed, ref } from 'vue';
import ISettingsSidebarRoute from '@/@types/interfaces/ISettingsSidebarRoute';
import { User } from '@/models/User';
import { isSnaploreClosedFor, usesBillingPages } from '@/helpers/appContext';


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsSidebar',
  setup(__props) {

const user = computed((): User => store.state.user);
// SNAP-2241: these pages are closed to a company that pays only for Guides, so they are not offered to it.
const isSnaploreClosed = computed((): boolean => isSnaploreClosedFor(store.state.company, store.state.user));
const showCompanySettings = computed(
  (): boolean => !!user.value && user.value.role !== 'user' && !isUserInactiveInCompany.value && !isSnaploreClosed.value
);
const isBillingEnabled = computed(() => usesBillingPages(store.state.company));
const isCompanyPaid = computed(() => store.state.company?.isPaid);
const isOwner = computed((): boolean => store.state.user.isOwner());

const isUserInactiveInCompany = computed((): boolean => store.state.isUserInactiveInCompany);

const filteredCompanySettings = computed((): ISettingsSidebarRoute[] => {
  if (user.value && user.value.role === 'moderator') {
    return companySettings.value.filter((item: ISettingsSidebarRoute) => item.key !== 'company');
  }
  return companySettings.value;
});

const personalSettings = ref<ISettingsSidebarRoute[]>([
  {
    title: 'Personal Profile',
    path: '/settings/profile',
    key: 'profile',
  },
  {
    title: 'Integrations',
    path: '/settings/integrations',
    key: 'integrations',
  },
  {
    // SNAP-2389. Personal, not company: it only ever shows the caller's own sessions, and a
    // user deactivated in their company must still be able to reach it (the backend
    // allowlists these routes for exactly that reason).
    title: 'Active Sessions',
    path: '/settings/sessions',
    key: 'sessions',
  },
]);

const visiblePersonalSettings = computed((): ISettingsSidebarRoute[] =>
  isSnaploreClosed.value ? personalSettings.value.filter((item) => item.key !== 'integrations') : personalSettings.value
);
const companySettings = ref<ISettingsSidebarRoute[]>([
  {
    title: 'Company Profile',
    path: '/settings/company',
    key: 'company',
  },
  {
    title: 'User Management',
    path: '/settings/users',
    key: 'management',
  },
  {
    title: 'User Groups',
    path: '/settings/groups',
    key: 'groups',
  },
]);

const billingSettings = ref<ISettingsSidebarRoute[]>([
  {
    title: 'Subscription',
    path: '/settings/billing/plan-details',
    key: 'plan-details',
  },
  {
    title: 'Billing history',
    path: '/settings/billing/history',
    key: 'history',
  },
]);

const handleSettingsRoute = (route: string) => {
  if (store.state.isMobile) {
    store.commit('toggleMainSidebar', false);
  }

  router.push(route);
};

const checkActiveSettings = (route: string): boolean => {
  const routes = useRoute();
  const currentRoutePath = computed((): string => routes.path);

  return currentRoutePath.value === route;
};

return { __sfc: true,user, isSnaploreClosed, showCompanySettings, isBillingEnabled, isCompanyPaid, isOwner, isUserInactiveInCompany, filteredCompanySettings, personalSettings, visiblePersonalSettings, companySettings, billingSettings, handleSettingsRoute, checkActiveSettings }
}

})